/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="modal-header">\n  <button type="button" class="close" data-dismiss="modal">×</button>\n  <h1 class="header-text">' +
__e( data.headerText ) +
'</h1>\n\n</div>\n<div class="modal-body">\n  <div class="add-media-choices-wrapper">\n    ';
 if (_.includes(data.enabledInputs, 'library')) { ;
__p += '\n    <div class="add-media-choice action-add-from-media-library">\n      <img src="https://d3jozdooylvm2p.cloudfront.net/images/icons/add-modal/add_from_med-lib-2.png" class="add-media-lib">\n        Add from Media Library\n    </div>\n    ';
 } ;
__p += '\n    ';
 if (_.includes(data.enabledInputs, 'text')) { ;
__p += '\n      <div class="add-media-choice action-add-text">\n        <img src="https://d3jozdooylvm2p.cloudfront.net/images/icons/add-modal/add_text-2.png" class="add-text">\n        Add Text tile\n      </div>\n    ';
 } ;
__p += '\n    ';
 if (_.includes(data.enabledInputs, 'upload')) { ;
__p += '\n      <div class="add-media-choice action-upload-file">\n        <img src="https://d3jozdooylvm2p.cloudfront.net/images/icons/add-modal/add_from_computer-2.png" class="add-file">\n          Upload File\n      </div>\n    ';
 } ;
__p += '\n    ';
 if (_.includes(data.enabledInputs, 'recording')){ ;
__p += '\n      <div class="add-media-choice action-add-recording">\n        <img src="https://d3jozdooylvm2p.cloudfront.net/images/icons/add-modal/add_video-2.png" class="add-recording">\n          Record Video\n      </div>\n    ';
 } ;
__p += '\n    ';
 if (_.includes(data.enabledInputs, 'youtube')) { ;
__p += '\n      <div class="add-media-choice action-add-youtube">\n        <img src="https://d3jozdooylvm2p.cloudfront.net/images/icons/add-modal/add_youtube-2.png" class="add-youtube">\n        Add YouTube video\n      </div>\n    ';
 } ;
__p += '\n    ';
 if (_.includes(data.enabledInputs, 'presentation')) { ;
__p += '\n      <div class="add-media-choice action-add-presentation">\n        <div class="add-presentation-icon"></div>\n        Add Presentation\n      </div>\n    ';
 } ;
__p += '\n    ';
 if (_.includes(data.enabledInputs, 'html_package')) { ;
__p += '\n      <div class="add-media-choice action-add-html-package">\n        <div class="add-html-package-icon"></div>\n        Add HTML Package\n      </div>\n    ';
 } ;
__p += '\n    ';
 if (_.includes(data.enabledInputs, 'internal_link') || _.includes(data.enabledInputs, 'external_link')) { ;
__p += '\n      <div class="add-media-choice action-add-link">\n       <img src="https://d3jozdooylvm2p.cloudfront.net/images/icons/add-modal/add_link-2.png" class="add-link">\n       Add Link\n      </div>\n    ';
 } ;
__p += '\n    ';
 if (_.includes(data.enabledInputs, 'form')) { ;
__p += '\n      <div class="add-media-choice action-add-form">\n          <img src="https://d3jozdooylvm2p.cloudfront.net/images/icons/add-modal/add_form-2.png" class="add-form">\n         Add Form\n      </div>\n    ';
 } ;
__p += '\n  </div>\n</div>\n\n<div class="confirm-create-presentation-modal-container"></div>\n<div class="confirm-create-html-package-modal-container"></div>\n';
return __p
}
